import React from 'react';

interface LinkedInIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const LinkedInIcon: React.FC<LinkedInIconProps> = ({
  width = 20,
  height = 20,
  fill = '#0f0f0f',
}) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 20 20"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m17.0409 17.0413h-2.9633v-4.6409c0-1.1067-.0198-2.53128-1.5413-2.53128-1.5434 0-1.7796 1.20578-1.7796 2.45078v4.7211h-2.96333v-9.54359h2.84483v1.30424h.0398c.2847-.4868.6961-.88726 1.1904-1.15874s1.053-.4038 1.6165-.38288c3.0035 0 3.5573 1.97565 3.5573 4.54587zm-12.59121-10.84843c-.34012.00006-.67262-.10074-.95546-.28966-.28283-.18892-.50329-.45747-.63351-.77168-.13021-.31422-.16433-.66-.09804-.99361.0663-.33361.23003-.64007.47049-.88062.24045-.24055.54684-.4044.88042-.47081.33357-.06642.67935-.03243.9936.09768.31426.13011.58287.35048.77189.63326.18901.28278.28993.61525.28999.95538.00004.22584-.0444.44948-.13079.65815-.08638.20866-.21302.39827-.37268.55799s-.34921.28643-.55784.37289c-.20862.08646-.43224.13098-.65807.13103zm1.48169 10.84843h-2.96646v-9.54389h2.96646zm12.58692-17.03993787h-17.04248c-.38681-.00436537-.75954.14502387-1.036271.41533887-.276732.270316-.43482812.639439-.439549 1.026269v17.11373c.0045593.387.162554.7564.439276 1.027s.649534.4203 1.036544.4162h17.04248c.3878.0048.7616-.1444 1.0395-.415.2778-.2706.4368-.6404.4422-1.0282v-17.11497c-.0055-.38759-.1647-.757134-.4425-1.027443s-.6516-.41927153-1.0392-.41415965"
      fill={fill}
    />
  </svg>
);

export default LinkedInIcon;
